// @ts-check
import { paramValues } from './paramValues';
import { params } from './storeParams';

/**
 * Resets all parameters to their default values.
 * @returns {void}
 */
export function resetParams() {
  for (const [name, param] of Object.entries(paramValues)) {
    const key = /** @type {import('./storeParams').ParameterKeys} */ (name);

    if (Object.hasOwn(params, key)) {
      param.value = params[key].defaultValue;
    }
  }
}
